import { initContract } from '@ts-rest/core';
import { ZReviewFields, ZWinnerFields } from '@daymade/common-lib/dbJsonModels';
import { z } from 'zod';
import { ZCmsDocumentStatus } from './cms.admin.contract';

const c = initContract();

const ZNotFound = z.object({ message: z.string() });

// ─── Shared document wrapper ───────────────────────────────────────────────────

function documentSchema<T extends z.ZodRawShape>(dataShape: T) {
  return z.object({
    id: z.number(),
    sortOrder: z.number().int(),
    status: ZCmsDocumentStatus,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    data: z.object(dataShape),
  });
}

// API response uses .partial() because JSONB rows from old documents may be missing keys
export const ZWinnerDocument = documentSchema(ZWinnerFields.partial().shape);
export const ZReviewDocument = documentSchema(ZReviewFields.partial().shape);

// ─── Contract ─────────────────────────────────────────────────────────────────

export const publicCmsContract = c.router({
  listWinners: {
    method: 'GET',
    path: '/winners',
    responses: {
      200: ZWinnerDocument.array(),
    },
    summary: 'List published Winner documents',
  },

  getWinner: {
    method: 'GET',
    path: '/winners/:id',
    pathParams: z.object({ id: z.coerce.number() }),
    responses: {
      200: ZWinnerDocument,
      404: ZNotFound,
    },
    summary: 'Get a published Winner document by ID',
  },

  listReviews: {
    method: 'GET',
    path: '/reviews',
    responses: {
      200: ZReviewDocument.array(),
    },
    summary: 'List published Review documents',
  },

  getReview: {
    method: 'GET',
    path: '/reviews/:id',
    pathParams: z.object({ id: z.coerce.number() }),
    responses: {
      200: ZReviewDocument,
      404: ZNotFound,
    },
    summary: 'Get a published Review document by ID',
  },
}, { pathPrefix: '/public', strictStatusCodes: true });
